export class ListGoogleWorkspaceOrgUnits200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "orgUnits",
            "baseName": "orgUnits",
            "type": "Array<GoogleWorkspaceOrgUnit>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGoogleWorkspaceOrgUnits200Response.attributeTypeMap;
    }
    constructor() {
    }
}
